module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("A Note to the Reader")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("In order to safeguard the privacy and security of the individuals mentioned in this book, all names have been changed. The events recounted here are derived from recorded interviews during which incidents and details were recalled to the best of the interviewee’s memory some ten years after their occurrence. All dialogue has been reconstructed and, in some cases, ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("translated from Arabic. Conversations in this book are not ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("verbatim, but are renderings of what was said and what ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("transpired at the time. The views expressed in this book do ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("not represent the views of the Department of Defense or ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("any of its affiliates.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78339fbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VoicingtheEagle23.vue
// module id = 66
// module chunks = 0